/**
 * @generated SignedSource<<b0307e8d9197573baf15fa5aa7169d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArticleSearchOrderFieldEnum = "PUBLISHED_DATE" | "RELEVANCE" | "%future added value";
export type ContentTypeEnum = "ARTICLE" | "GALLERY" | "PAGE" | "PODCAST" | "POSTIES_EVENT" | "RECIPE" | "STORY" | "VIDEO" | "%future added value";
export type SortOrderEnum = "ASC" | "DESC" | "%future added value";
export type ArticlesSearchOrderByInput = {
  direction?: SortOrderEnum | null | undefined;
  field?: ArticleSearchOrderFieldEnum | null | undefined;
};
export type searchResultPanelQuery$variables = {
  after?: string | null | undefined;
  articleTypeIds?: ReadonlyArray<string> | null | undefined;
  contentTypes?: ReadonlyArray<ContentTypeEnum> | null | undefined;
  endDate?: number | null | undefined;
  first?: number | null | undefined;
  orderBy?: ArticlesSearchOrderByInput | null | undefined;
  paywallTypeIds?: ReadonlyArray<string> | null | undefined;
  query: string;
  sectionIds?: ReadonlyArray<string> | null | undefined;
  startDate?: number | null | undefined;
};
export type searchResultPanelQuery$data = {
  readonly sectionSearch: {
    readonly " $fragmentSpreads": FragmentRefs<"searchResultListSectionSearchConnection">;
  } | null | undefined;
  readonly topicSearch: {
    readonly " $fragmentSpreads": FragmentRefs<"searchResultListTopicSearchConnection">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersSectionMenuQuery" | "helpersTypeMenuQuery" | "searchResultListArticleSearchQuery">;
};
export type searchResultPanelQuery = {
  response: searchResultPanelQuery$data;
  variables: searchResultPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articleTypeIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paywallTypeIds"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionIds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v10 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "articleTypes",
        "variableName": "articleTypeIds"
      },
      {
        "kind": "Variable",
        "name": "contentTypes",
        "variableName": "contentTypes"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "paywallTypeIds",
        "variableName": "paywallTypeIds"
      },
      (v10/*: any*/),
      {
        "kind": "Variable",
        "name": "sectionIds",
        "variableName": "sectionIds"
      },
      {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doc_count",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSearchAggregationBucket",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleSearchAggregationBucketItem",
      "kind": "LinkedField",
      "name": "buckets",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "RootArgument",
    "name": "after"
  },
  {
    "kind": "RootArgument",
    "name": "articleTypeIds"
  },
  {
    "kind": "RootArgument",
    "name": "contentTypes"
  },
  {
    "kind": "RootArgument",
    "name": "endDate"
  },
  {
    "kind": "RootArgument",
    "name": "first"
  },
  {
    "kind": "RootArgument",
    "name": "orderBy"
  },
  {
    "kind": "RootArgument",
    "name": "paywallTypeIds"
  },
  {
    "kind": "RootArgument",
    "name": "query"
  },
  {
    "kind": "RootArgument",
    "name": "sectionIds"
  },
  {
    "kind": "RootArgument",
    "name": "startDate"
  }
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleSearchAggregationBucketItem",
    "kind": "LinkedField",
    "name": "buckets",
    "plural": true,
    "selections": [
      (v13/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSearchAggregationBucket",
  "kind": "LinkedField",
  "name": "articleTypeId",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSearchAggregationBucket",
  "kind": "LinkedField",
  "name": "contentType",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v19 = [
  {
    "fields": [
      (v10/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v30 = [
  (v23/*: any*/),
  (v21/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v30/*: any*/),
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v30/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v38 = [
  (v23/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v20/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v38/*: any*/),
              "type": "Section",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v38/*: any*/),
              "type": "VideoSection",
              "abstractKey": null
            },
            (v39/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v44 = [
  (v23/*: any*/),
  (v25/*: any*/)
],
v45 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchResultPanelQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "searchResultListArticleSearchQuery"
      },
      {
        "kind": "InlineDataFragmentSpread",
        "name": "helpersSectionMenuQuery",
        "selections": [
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "ArticleSearchResult",
            "kind": "LinkedField",
            "name": "articleSearchV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleSearchAggregation",
                "kind": "LinkedField",
                "name": "aggregations",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "args": null,
        "argumentDefinitions": (v15/*: any*/)
      },
      {
        "kind": "InlineDataFragmentSpread",
        "name": "helpersTypeMenuQuery",
        "selections": [
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "ArticleSearchResult",
            "kind": "LinkedField",
            "name": "articleSearchV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleSearchAggregation",
                "kind": "LinkedField",
                "name": "aggregations",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "args": null,
        "argumentDefinitions": (v15/*: any*/)
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "TopicSearchConnection",
        "kind": "LinkedField",
        "name": "topicSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "searchResultListTopicSearchConnection"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "SectionSearchConnection",
        "kind": "LinkedField",
        "name": "sectionSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "searchResultListSectionSearchConnection"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "searchResultPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "ArticleSearchResult",
        "kind": "LinkedField",
        "name": "articleSearchV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleSearchConnection",
            "kind": "LinkedField",
            "name": "connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleSearchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleSearchResultItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleSearchAggregation",
            "kind": "LinkedField",
            "name": "aggregations",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "ArticleSearchConnection",
        "kind": "LinkedField",
        "name": "articleSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleSearchEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleSearchResultItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isContent"
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          (v21/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "type": "AUTHOR_IMAGE"
                                }
                              }
                            ],
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "300x300"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v27/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"300x300\"})"
                              }
                            ],
                            "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v31/*: any*/),
                              (v33/*: any*/),
                              (v37/*: any*/),
                              (v42/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sponsor",
                            "kind": "LinkedField",
                            "name": "sponsor",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": (v27/*: any*/),
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v44/*: any*/),
                                "type": "Section",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v44/*: any*/),
                                "type": "VideoSection",
                                "abstractKey": null
                              },
                              (v39/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publishedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readingTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flag",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          {
                            "alias": "size540x360",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "style": "540x360"
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"540x360\"})"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "socialHeadline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "printHeadline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "summary",
                        "plural": false,
                        "selections": (v45/*: any*/),
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v28/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v41/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sponsorType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "multimediaEmbed",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "json",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v23/*: any*/),
                                  (v21/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "description",
                                    "plural": false,
                                    "selections": (v45/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasVideoContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Author",
                            "kind": "LinkedField",
                            "name": "authors",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "types",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v40/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "duration",
                            "storageKey": null
                          },
                          (v36/*: any*/)
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Gallery",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "filters": [
          "filter",
          "orderBy"
        ],
        "handle": "connection",
        "key": "articleSearchResultListQuery__articleSearch",
        "kind": "LinkedHandle",
        "name": "articleSearch"
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "TopicSearchConnection",
        "kind": "LinkedField",
        "name": "topicSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicSearchEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TopicSearchResultItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v25/*: any*/),
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v24/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/),
                          (v42/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "SectionSearchConnection",
        "kind": "LinkedField",
        "name": "sectionSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SectionSearchEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSearchResultItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "fullSectionPath",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v24/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "fullSectionPath",
                                "plural": true,
                                "selections": (v38/*: any*/),
                                "storageKey": null
                              },
                              (v32/*: any*/)
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          (v37/*: any*/),
                          (v42/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "275e0aef7f01c714722ee8dbfeed5d38",
    "id": null,
    "metadata": {},
    "name": "searchResultPanelQuery",
    "operationKind": "query",
    "text": "query searchResultPanelQuery(\n  $query: String!\n  $articleTypeIds: [String!]\n  $sectionIds: [String!]\n  $contentTypes: [ContentTypeEnum!]\n  $paywallTypeIds: [String!]\n  $orderBy: ArticlesSearchOrderByInput\n  $first: Int = 10\n  $after: String\n  $startDate: Timestamp\n  $endDate: Timestamp\n) {\n  ...searchResultListArticleSearchQuery\n  ...helpersSectionMenuQuery\n  ...helpersTypeMenuQuery\n  topicSearch(first: 10, filter: {query: $query}) {\n    ...searchResultListTopicSearchConnection\n  }\n  sectionSearch(first: 10, filter: {query: $query}) {\n    ...searchResultListSectionSearchConnection\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleSearchResultListQuery on Query {\n  articleSearch(filter: {query: $query, sectionIds: $sectionIds, articleTypes: $articleTypeIds, paywallTypeIds: $paywallTypeIds, contentTypes: $contentTypes, startDate: $startDate, endDate: $endDate}, orderBy: $orderBy, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        score\n        content {\n          __typename\n          ...searchContentItemContent\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentPrintHeadlineContent on Content {\n  __isContent: __typename\n  printHeadline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionMenuQuery on Query {\n  articleSearchV2(filter: {query: $query, sectionIds: $sectionIds, articleTypes: $articleTypeIds, paywallTypeIds: $paywallTypeIds, contentTypes: $contentTypes, startDate: $startDate, endDate: $endDate}, orderBy: $orderBy, first: $first, after: $after) {\n    aggregations {\n      section {\n        buckets {\n          key\n          doc_count\n        }\n      }\n    }\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersTypeMenuQuery on Query {\n  articleSearchV2(filter: {query: $query, sectionIds: $sectionIds, articleTypes: $articleTypeIds, paywallTypeIds: $paywallTypeIds, contentTypes: $contentTypes, startDate: $startDate, endDate: $endDate}, orderBy: $orderBy, first: $first, after: $after) {\n    aggregations {\n      articleTypeId {\n        buckets {\n          doc_count\n          key\n        }\n      }\n      contentType {\n        buckets {\n          doc_count\n          key\n        }\n      }\n    }\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_mi5hC on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentPrintHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n    ...indicatorGalleryIndicatorGallery\n  }\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment indicatorGalleryIndicatorGallery on Gallery {\n  images {\n    __typename\n  }\n}\n\nfragment searchContentItemContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  authors {\n    entityId\n    id\n  }\n  topics {\n    entityId\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_mi5hC\n  ...hooksPlusArticleLinkHandlerArticle\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...helpersCheckIsPlusArticle\n}\n\nfragment searchResultListArticleSearchQuery on Query {\n  articleSearchV2(filter: {query: $query, sectionIds: $sectionIds, articleTypes: $articleTypeIds, paywallTypeIds: $paywallTypeIds, contentTypes: $contentTypes, startDate: $startDate, endDate: $endDate}, orderBy: $orderBy, first: $first, after: $after) {\n    connection {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n      totalCount\n    }\n  }\n  ...articleSearchResultListQuery\n}\n\nfragment searchResultListSectionSearchConnection on SectionSearchConnection {\n  edges {\n    node {\n      __typename\n      id\n    }\n  }\n  ...sectionSearchResultListSectionSearchConnection\n}\n\nfragment searchResultListTopicSearchConnection on TopicSearchConnection {\n  edges {\n    node {\n      __typename\n      id\n    }\n  }\n  ...topicSearchResultListTopicSearchConnection\n}\n\nfragment sectionSearchResultListItemSection on Section {\n  fullSectionPath {\n    ...helpersCheckIfNewsSectionInFirstIndexSection\n    name\n    id\n  }\n  entityId\n  ...entityLink\n}\n\nfragment sectionSearchResultListSectionSearchConnection on SectionSearchConnection {\n  edges {\n    node {\n      score\n      content {\n        entityId\n        fullSectionPath {\n          ...helpersCheckIfNewsSectionInFirstIndexSection\n          name\n          id\n        }\n        ...sectionSearchResultListItemSection\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicSearchResultListItemTopic on Topic {\n  entityId\n  name\n  ...entityLink\n}\n\nfragment topicSearchResultListTopicSearchConnection on TopicSearchConnection {\n  edges {\n    node {\n      score\n      content {\n        entityId\n        ...topicSearchResultListItemTopic\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fef6c8587ef9c3d6470c381c89d20f7d";

export default node;
